import { useEffect } from "react";
import { AuthNav, SideNav } from "../../../components/Navbar/Webpages/AuthNav";
import { useDispatch, useSelector } from "react-redux";
import { getUserPaymentsRequest } from "../../../redux/action";
import toast from "react-hot-toast";
import { CircularProgress } from "@material-ui/core";
import { TransactionCard } from "../../../components/Cards/TransactionCard";

const Deposits = () => {
  const dispatch = useDispatch();

  const { getUserPaymentsError, getUserPaymentsLoading, payments, user } =
    useSelector((state) => {
      const {
        success: { getUserPayments: getUserPaymentsSuccess },
        errors: { getUserPayments: getUserPaymentsError },
      } = state.ajaxStatuses;

      const { getUserPaymentsLoading } = state.loadingIndicator;

      const { payments } = state.paymentData;

      const { user, token } = state.userData;

      return {
        getUserPaymentsSuccess,
        getUserPaymentsError,
        getUserPaymentsLoading,
        payments,
        user,
      };
    });

  useEffect(() => {
    if (getUserPaymentsError) {
      toast.error(getUserPaymentsError, {
        duration: 3000,
      });
    }
  }, [getUserPaymentsError]);

  useEffect(() => {
    dispatch(getUserPaymentsRequest(user._id));
  }, [getUserPaymentsRequest]);

  return (
    <div>
      <AuthNav title={"Deposits History"} />
      <SideNav />

      <div className="container max-w-screen-xl mx-auto px-4  pt-20">
        <h5 className=" text-xl  font-semibold font-heading ">Deposits</h5>
        <div className="mt-3">
          {getUserPaymentsLoading ? (
            <div className="text-center col-span-3 justify-self-center align-self-center my-36">
              {" "}
              <CircularProgress size="20px" />
            </div>
          ) : payments && payments.length > 0 ? (
            payments
              .filter((payment) => payment.type === "Deposite")
              .map((payment, index) => (
                <TransactionCard payment={payment} key={index} />
              ))
          ) : (
            <div className="bg-gray py-8 mx-auto max-w-xl">
              <p className="text-center">No deposits made by you yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Deposits;
